
/*
    Form for creating or editing a user record for the PCS app
*/

import React, { createRef } from "react";

import LocationDropdown from "../Components/LocationDropDown";

import * as UtilityRequests from "../Requests/UtilityRequests";
import * as UserRequests from "../Requests/UserRequests";

import { scrollToRef } from "../Scripts/Utilities";

export default class UserManagementForm extends React.Component {

    constructor(){
        super();

        this.state = {
            id: null,
            first_name: "",
            middle_initial: "",
            last_name: "",
            username: "",
            location: "",
            role: "Starter",
            locationList: [],
            roleList: ["Starter", "Supervisor", "Administrator", "Operator", "Report"],
            isEdit: false,
            enabled: true,
            first_name_missing: false,
            last_name_missing: false,
            username_missing: false,
            groupid: "BUS"
        };

        this.focusRef = createRef();
    }

    componentDidMount(){
        // if there was a value passed in, then fill in the state
        if(this.props.data && this.props.data.userfname){
            const user = this.props.data;

            console.log("EDITING USER", user);

            this.setState({
                isEdit: true, 
                first_name: user.userfname,
                middle_initial: user.usermname,
                last_name: user.userlname,
                username: user.username,
                location: user.locationid,
                role: user.role,
                enabled: user.status === "ENABLED",
                groupid: user.groupID
            });
        }

        scrollToRef(this.focusRef.current);
    }

    updateValue = (evt) => {
        this.setState({[evt.target.name]:evt.target.value});
    }

    submit = () => {
        const values = {
            first_name: this.state.first_name,
            middle_initial: this.state.middle_initial,
            last_name: this.state.last_name,
            username: this.state.username,
            location: this.state.location,
            role: this.state.role,
            enabled: this.state.enabled,
            groupid: this.state.groupid
        };

        console.log("SUBMIT VALUES", values);

        // display error messages for missing values
        const f_miss = !this.state.first_name;
        const l_miss = !this.state.last_name;
        const u_miss = !this.state.username;

        console.log("MISSING VALUES?", f_miss, l_miss, u_miss);

        if(f_miss || l_miss || u_miss){
            this.setState({
                first_name_missing: f_miss,
                last_name_missing: l_miss,
                username_missing: u_miss
            });
        }
        else{            
            this.props.submit(values, this.props.index);
        }
    }

    render(){
        return (
            <>
            <div>
                <div className="form-element-horizontal">
                    <label>Group</label>
                    <select ref={this.focusRef} name="groupid" value={this.state.groupid} onChange={this.updateValue}>
                        <option value="BUS">Bus</option>
                        <option value="RL">River Line</option>
                        <option value="NLR">Newark Light Rail</option>
                    </select>
                </div>
                <div className="form-element-horizontal">
                    <div>
                        <label>First Name</label>
                        {
                            this.state.first_name_missing
                            ? <span style={{color: "var(--red)"}}>&nbsp;[required]</span>
                            : null
                        }
                    </div>
                    <input type="text" name="first_name" value={this.state.first_name} onChange={this.updateValue} />                        
                </div>
                <div className="form-element-horizontal">
                    <label>M.I.</label>
                    <div>
                        <input 
                            size="1" maxLength="1"
                            type="text" name="middle_initial" value={this.state.middle_initial} onChange={this.updateValue} 
                        />
                    </div>
                </div>
                <div className="form-element-horizontal">
                    <div>
                        <label>Last Name</label>
                        {
                            this.state.last_name_missing
                            ? <span style={{color: "var(--red)"}}>&nbsp;[required]</span>
                            : null
                        }
                    </div>
                    <input type="text" name="last_name" value={this.state.last_name} onChange={this.updateValue} />
                </div>
                <div className="form-element-horizontal">
                    <div>
                        <label>Username</label>
                        {
                            this.state.username_missing
                            ? <span style={{color: "var(--red)"}}>&nbsp;[required]</span>
                            : null
                        }
                    </div>
                    <input type="text" name="username" value={this.state.username} onChange={this.updateValue} />
                </div>
                <div className="form-element-horizontal">
                    <label>Location</label>
                    <LocationDropdown 
                        selected={this.state.location}
                        updateValue={this.updateValue} 
                    />
                </div>
                <div className="form-element-horizontal">
                    <label>Role</label>
                    <select name="role" value={this.state.role} onChange={this.updateValue}>
                    {
                        this.state.roleList.map((role, index) => {
                            return <option key={index} value={role}>{role}</option>
                        })
                    }
                    </select>
                </div>
                <div className="form-element-horizontal">
                    <label>Enabled</label>
                    <select name="enabled" value={this.state.enabled} onChange={this.updateValue}>
                        <option value={true}>Enabled</option>
                        <option value={false}>Disabled</option>
                    </select>
                </div>
                <div className="option  " onClick={this.submit}>
                    {
                        this.state.isEdit 
                        ? "Update User"
                        : "Submit New User" 
                    }
                </div>
            </div>
            </>
        )
    }
}